export const copyText = (textToCopy) => {
  if ('clipboard' in navigator) {
    navigator.clipboard.writeText(textToCopy)
  } else {
    const textarea = document.createElement('textarea')
    textarea.value = textToCopy
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
  }
}
